exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3X8vo{float:left;position:relative;width:100%;background-color:#ebebeb;padding:20px;padding-top:75px;-webkit-box-sizing:border-box;box-sizing:border-box}.tXp0n{float:left;position:relative;width:100%;max-width:var(--max-content-width);max-width:var(--max-content-width);left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);margin-bottom:55px}._1I-76{position:relative;float:left;font-size:30px;padding:15px;padding-top:10px;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._3G9Lt{position:relative;float:left;padding:15px;margin:0}", ""]);

// exports
exports.locals = {
	"root": "_3X8vo",
	"termsContainer": "tXp0n",
	"headerOne": "_1I-76",
	"termsInfo": "_3G9Lt"
};